import React from "react";
import Pagination from "../../../components/Pagination";

/**
 * Desktop table view component for displaying products in a table layout
 * Includes sticky header and validation error handling
 */
const PriceTable = ({
  productRows,
  isCompactView,
  handleNewPriceChange,
  priceErrors,
  currencySymbol,
  page,
  totalPages,
  onPageChange,
}) => {
  return (
    <div className="h-full flex flex-col bg-white rounded-lg shadow-sm overflow-hidden">
      {/* Table */}
      <div className="flex-1 overflow-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-black sticky top-0 z-10">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                Product Name
              </th>
              {!isCompactView && (
                <>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                    Category
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                    Subcategory
                  </th>
                </>
              )}
              <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                Current Price
              </th>
              <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                Offer Price
              </th>
              <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                New Price
              </th>
              <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
                New Offer Price
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {productRows.map((row, index) => {
              const errorKey = row.variantId
                ? `${row._id}-${row.variantId}`
                : row._id;
              const hasError = priceErrors[errorKey];

              return (
                <tr
                  key={`${row._id}-${row.variantId || index}`}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3 text-sm font-medium text-gray-900">
                    {row.productName}
                  </td>
                  {!isCompactView && (
                    <>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {row.categoryName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {row.subcategoryName}
                      </td>
                    </>
                  )}
                  <td className="px-4 py-3 text-sm font-semibold text-green-600">
                    {currencySymbol}
                    {row.price}
                  </td>
                  <td className="px-4 py-3 text-sm font-semibold text-red-600">
                    {row.offerPrice != null && row.offerPrice !== "" && (
                      <>
                        {currencySymbol}
                        {row.offerPrice}
                      </>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <div className="relative">
                      <span className="absolute left-3 top-2.5 text-gray-500 text-sm">
                        {currencySymbol}
                      </span>
                      <input
                        type="number"
                        value={row.newPrice}
                        onChange={(e) =>
                          handleNewPriceChange(
                            row._id,
                            row.variantId,
                            e.target.value,
                            "newPrice",
                          )
                        }
                        className="pl-8 pr-3 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <div className="relative">
                      <span className="absolute left-3 top-2.5 text-gray-500 text-sm">
                        {currencySymbol}
                      </span>
                      <input
                        type="number"
                        value={row.newOfferPrice}
                        onChange={(e) =>
                          handleNewPriceChange(
                            row._id,
                            row.variantId,
                            e.target.value,
                            "newOfferPrice",
                          )
                        }
                        className={`pl-8 pr-3 py-2 w-full border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                          hasError
                            ? "border-red-500 bg-red-50"
                            : "border-gray-300"
                        }`}
                      />
                      {hasError && (
                        <p className="text-xs text-red-500 mt-1">
                          Cannot exceed price
                        </p>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="border-t border-gray-100 px-6 py-4">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default PriceTable;
